import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class LocalStorageService {
    enableNPAssaysFeature: boolean = false;

    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window && (window as any).config && (window as any).config.enableNPAssays !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.enableNPAssaysFeature = (window as any).config.enableNPAssays || false;
        }
    }

    // Set item in local storage
    setItem(key: string, value: string): void {
        try {
            const jsonValue = JSON.stringify(value);
            localStorage.setItem(key, jsonValue);
        } catch (error) {
            console.error('Error saving to local storage', error);
        }
    }

    // Get item from local storage
    getItem<T>(key: string): T | null {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;
        } catch (error) {
            console.error('Error reading from local storage', error);
            return null;
        }
    }

    // Remove item from local storage
    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    // Clear all local storage
    clear(): void {
        localStorage.clear();
    }

    isNPAssaysFeatureEnabled(): boolean {
        return this.enableNPAssaysFeature;
    }
}
